/* eslint-disable max-len */
import { ValidQuestionKeys } from '../hooks/useGerateQuestions'

const mapQuestionNames: Record<ValidQuestionKeys, string> = {
    titleComponent: 'Select the title of the invention and list all...',
    backgroundInvention:
        '{"machine":"If desired, you may include text for insertion in the Cross-Reference and Related Applications section. (Please discuss with a patent professional if you have questions.)","composition":"If desired, you may include text for insertion in the Cross-Reference and Related Applications section. (Please discuss with a patent professional if you have questions.)","manufacture":"Please write backround of the invention","method":"Please write backround of the invention"}',
    commonName:
        '{"machine":"If the machine has a common name, what is it?","composition":"If the composition has a common name, what is it?","manufacture":"If the manufacture has a common name, what is it?","method":"Describe what your method is for?"}',
    methodOutline: 'Now let?s create an outline of the method steps you ...',
    subSteps: 'Select the steps that have substeps you would like to ...',
    summaryOfSelectedEmbodimentsOfTheInvention:
        '{"machine":"Select the combination of components that you believe ...","composition":"Please write summary of selected embodiments of the ...","manufacture":"Please write summary of selected embodiments of the ...","method":"Please write summary of selected embodiments of the ..."}',
    doneDescribing: 'name',
    subcomponentsForCharacteristics:
        'Select the following subcomponents from ...',
    subFormatUserDefined:
        'Select a sub format for the user defined variable ...',
    subCharacteristic: 'Select characteristics that apply to the ...',
    subAdditionalCharacteristic:
        'Select the additional characteristics that you...',
    stepPracticalPercentageLimit:
        'Select the step that has practical limits on the percent ...',
    stepPracticalLimit:
        'Select the step that has practical limits on the weight ...',
    reviewPatent: 'After this patent application is filed, ...',
    primaryComponents: 'List the primary components of the machine ...',
    primaryAdditionalComponents:
        'If there are any additional components of the machine ...',
    additionalComponentsForCharacteristics:
        'Select the following additional components from ...',
    addCompCharacteristic: 'Select characteristics that apply to the ...',
    addCompAdditionalCharacteristic:
        'Select the additional characteristics that you...',
    addCompFormatUserDefined:
        'Select a format for the user defined variable ...',
    primaryComponentSubComponentsList: 'List the sub components of the ...',
    patentProfessionalReview:
        'Would you like a patent professional to review your ...',
    newProperty: 'name',
    methodOutlineInputs:
        'Does a component act on the input or inputs in this step?',
    additionalCharacteristic:
        'Select the additional characteristics that you ...',
    methodOutlineDescription:
        "Now let's get additional information on each step",
    measurableProperties: 'Does the whole object have measurable properties?',
    mainSubcomponents: 'Select the primary components that have ...',
    importantWeights:
        '{"composition":"List the weight percentages that are always required ...","manufacture":"Select the following components that are always requ ..."}',
    importantComponentsConnections:
        '{"machine":"Specify the physical connections between components","composition":"Select connections between components from Independ ...","manufacture":"Select connections between components"}',
    importantComponentsArrangements:
        'Now that we have looked at physical connections...',
    importantComponentsOrientations: 'name',
    importantComponents: 'Select the following components that are always ...',
    importantCharacteristic: 'Are any of the properties always required ...',
    functionalConnections:
        'Components related via a functional relationship...',
    formatUserDefined: 'Select a format for the user defined variable ...',
    embodimentNecessaryStep:
        'Select the steps that are always required in an ...',
    detailedDescription: 'Write detailed  description',
    describeMethod: 'Would you like to describe the method at this time?',
    componentsQuantity: 'Quantity',
    componentsForCharacteristics:
        'Select the components that have characteristics ...',
    componentWeights: 'For each component, list a maximum acceptable ...',
    characteristicExplanation:
        'Please explain why each property is advantageous',
    componentStepPracticalPercentageLimit:
        'For each input component or product composition, list ...',
    componentStepPracticalLimit:
        'For each component, list a maximum acceptable weight ...',
    characteristicMethodOutline:
        'Does the method include important measurable or ...',
    characteristicMethod: 'Does the method include important measurable or ...',
    characteristicCustom: 'Would you like to add a property that has not ...',
    characteristicCompositon: 'Choose property',
    characteristic: 'Select characteristics that apply to the ...',
    abstractOfTheDisclosure: 'Abstract of the disclosure',
    customBackgroundOfInvention:
        'List the advantage or desirable characteristic that your ...',
    dependantComponentsConnections:
        'For every component in a dependent claim, add ...',
    extraOptions: 'Do you want to add another component?',
    lastPane: 'none',
    drawingToolDescription: 'none',
    partsOfDependentClaim: 'none',
    partsOfIndependentClaim:
        'Select a combination of components that you believe...',
    featuresPartsOfIndependentClaim:
        'Select a combination of features that you believe are...',
    subSummaryOfSelectedEmbodimentsOfTheInvention:
        'Please select the combination of...',
    drawingsDescription: 'What type of illustration is provided in ...',
}

export default mapQuestionNames
